import {isOneDayDateFrame} from '../utils/dateFrames';
import showAlert from './showAlert';

export const ONE_DAY_DATEFRAME_CONFIRM_TITLE = 'One-day dateframe';
export const ONE_DAY_DATEFRAME_CONFIRM_MESSAGE =
  'Would you like to create this as a one-day dateframe?';

const confirmOneDayDateFrame = (
  startDate?: string | Date | null,
  endDate?: string | Date | null,
) => {
  if (!isOneDayDateFrame(startDate, endDate)) {
    return Promise.resolve(true);
  }

  return new Promise<boolean>(resolve => {
    showAlert(
      ONE_DAY_DATEFRAME_CONFIRM_TITLE,
      ONE_DAY_DATEFRAME_CONFIRM_MESSAGE,
      () => resolve(false),
      () => resolve(true),
    );
  });
};

export default confirmOneDayDateFrame;
